import ClearingAPI from '@shared/api';

export const {
    positions: { getAssignedPosition, getBrokerLevelClient },
} = ClearingAPI.settings;
